export type LogoutAction = (() => void | Promise<void>) | undefined;

export type LogoutState = {
  inFlight: boolean;
};

type RunBlockingLogoutArgs = {
  action: LogoutAction;
  state: LogoutState;
  onPendingChange?: (pending: boolean) => void;
};

/**
 * Shared contract for shell logout handlers:
 * - no fire-and-forget
 * - no concurrent logout runs
 * - always release pending state in finally
 */
export const runBlockingLogout = async ({
  action,
  state,
  onPendingChange,
}: RunBlockingLogoutArgs): Promise<boolean> => {
  if (!action || state.inFlight) {
    return false;
  }

  state.inFlight = true;
  onPendingChange?.(true);

  try {
    await action();
    return true;
  } finally {
    state.inFlight = false;
    onPendingChange?.(false);
  }
};
